import React from 'react';
import { Navigate } from 'react-router-dom';
import { replace } from 'ramda';
import Loading from 'components/Loading';
import {
  ROUTE_PARAM_IDENTIFIER as ProjectAreaParamIdentifier,
  STOPES_ROUTE_PATH as ProjectStopesRoutePath
} from 'modules/project/ProjectAreaPage/constants';
import { ROUTE_PATH as PROJECTS_ROUTE } from 'modules/project/ProjectsPage/constants';
import { useProjectsQuery } from 'providers/api';

const stopesUrlFor = (entityId: string) => replace(
  ProjectAreaParamIdentifier,
  entityId,
  ProjectStopesRoutePath,
).replace('/*', '');

const ProjectsRootRedirect: React.FC = () => {
  const { data, isLoading, isError } = useProjectsQuery({
    page: 1,
    pageSize: 2,
    clientId: null,
    searchTerm: null,
  });

  if (isLoading) {
    return <Loading />;
  }

  if (isError || !data) {
    return <Navigate to={PROJECTS_ROUTE} replace />;
  }

  if (data.pager.totalItems === 1 && data.items.length === 1) {
    return <Navigate to={stopesUrlFor(data.items[0].entityId)} replace />;
  }

  return <Navigate to={PROJECTS_ROUTE} replace />;
};

export default ProjectsRootRedirect;
